import styled from 'styled-components'

import { Flex } from '@/ui/atoms/flex'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const SellerCardDetailsContainer = styled.div(
  ({ theme }) => `
  column-gap: ${theme.spacing.giant};
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${theme.spacing.default};

  
  ${MEDIA_QUERIES(theme).medium}{
    grid-template-columns: max-content auto;
  }
`
)

/** Side Profile */

export const VipSideProfileTopContainer = styled.div(
  ({ theme }) => `  
  ${MEDIA_QUERIES(theme).large} {
    box-shadow: 0 .2rem .4rem #2d2f3b1f;
    padding: ${theme.spacing.large} ${theme.spacing.large} 0;
    border-radius: ${theme.borderRadius.medium} ${theme.borderRadius.medium} 0 0;
    border: .1rem solid ${theme.colors.grey.light4};
    border-bottom: none;
  }
`
)

export const VipSideProfileStickyContainer = styled.div<{ hasTopContainer?: boolean }>(
  ({ theme, hasTopContainer }) => `
  padding: 0 0 ${theme.spacing.large} 0;
  position: sticky;
  top: 0;
  
  
  ${MEDIA_QUERIES(theme).large}{
    box-shadow: 0 .2rem .4rem #2d2f3b1f;
    border-radius: 0 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium};
    border: .1rem solid ${theme.colors.grey.light4};
    border-top: none;
    padding: ${theme.spacing.default} ${theme.spacing.large} ${theme.spacing.large};

    ${
      !hasTopContainer &&
      `
      border-top: .1rem solid ${theme.colors.grey.light4};
      border-radius: ${theme.borderRadius.medium};`
    }
  }
`
)

export const VipSideProfileLogoContainer = styled.div(
  ({ theme }) => `
  display: none;
  width: 100%;

  ${MEDIA_QUERIES(theme).large} {
    display: block;
  }
`
)

// eslint-disable-next-line @kijiji/prefer-image-custom
export const VipSideProfileLogo = styled.img(
  ({ theme }) => `
  border-radius: ${theme.borderRadius.small};
  max-height: 6rem;
  padding-bottom: ${theme.spacing.default};
`
)

/** Inline With Icon Items */
export const VipSideProfileOverviewSection = styled(Flex)(
  ({ theme }) => `
  padding-bottom: ${theme.spacing.default};
  border-bottom: .1rem solid ${theme.colors.grey.light4};
  
  & > svg {
    color: ${theme.colors.purple.primary};
  }
`
)

export const RequestViewingMobileContainer = styled(Flex)(
  ({ theme }) => `
  padding-bottom: ${theme.spacing.default};
  border-bottom: .1rem solid ${theme.colors.grey.light4};
  
  ${MEDIA_QUERIES(theme).large} {
    display: none;
  }
`
)
